export default __webpack_public_path__ + "assets/images/ad91336ef03abe4763052bc0c6ce084d.svg";